export default "__VITE_ASSET__Bhc$$sfn__"